import { supabase } from './supabase';
import { v4 as uuidv4 } from 'uuid';

export const uploadImageToSupabase = async (base64Image: string): Promise<string> => {
  try {
    // Extract content type and base64 data
    const [contentType, base64Data] = base64Image.split(';base64,');
    const fileExt = contentType.split('/')[1];
    const fileName = `${uuidv4()}.${fileExt}`;

    // Convert base64 to Uint8Array
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Upload to Supabase Storage
    const { data, error } = await supabase.storage
      .from('room-images')
      .upload(fileName, byteArray, {
        contentType,
        upsert: false
      });

    if (error) throw error;

    // Get public URL
    const { data: { publicUrl } } = supabase.storage
      .from('room-images')
      .getPublicUrl(data.path);

    return publicUrl;
  } catch (error) {
    console.error('Error uploading image:', error);
    throw error;
  }
};